import React, { useState } from 'react'
import { Card } from 'primereact/card'
import utils from '../../../utils'
import { Button } from 'primereact/button'
import { icons } from '../../../constants'
import { Message } from 'primereact/message'
import { ProgressSpinner } from 'primereact/progressspinner'
import RenomarAnexoModal from './renomar-anexo-modal'

export default function OrcamentoAnexo(props) {
  const [showRenameDialog, setShowRenameDialog] = useState(false)
  const [anexoToRename, setAnexoToRename] = useState()

  function getContent() {
    const anexos = props.anexos
    if (utils.isArrayNullOrEmpty(anexos)) {
      return null
    }

    return anexos.map((anexo, index) => (
      <div className="p-grid p-fluid" key={index}>
        <div className="p-col">
          <Button
            type="p-button"
            label={anexo.filename}
            onClick={(e) => props.downloadAnexo(anexo)}
            icon={icons.DOWNLOAD}
            className="p-button-secondary"
            disabled={isNaN(anexo.oid)}
          />
        </div>
        <div className="p-col-1">
          <Button
            type="p-button-icon"
            icon={icons.REMOVE_ICON}
            onClick={(e) => props.removeAnexo(anexo)}
            className="p-button-danger"
            style={{ marginRight: '.25em' }}
          />
        </div>
        <div className="p-col-1">
          <Button
            type="p-button-icon"
            icon={icons.PENCIL_ICON}
            onClick={(e) => onClickRename(anexo)}
            disabled={isNaN(anexo.oid)}
          />
        </div>
      </div>
    ))
  }

  const onClickRename = (anexo) => {
    setAnexoToRename(anexo)
    setShowRenameDialog(true)
  }

  const onHideRenameDialog = () => {
    setShowRenameDialog(false)
  }

  const confirmarRename = ({ nomeAnexo, anexoToRename }) => {
    anexoToRename.filename = nomeAnexo
    props.renomearAnexo(anexoToRename)
  }

  function getModalRenameAnexo() {
    return (
      <RenomarAnexoModal
        messages={props.messages}
        onConfirm={confirmarRename}
        visible={showRenameDialog}
        onHide={onHideRenameDialog}
        anexoToRename={anexoToRename}
      />
    )
  }

  return (
    <div>
      {getModalRenameAnexo()}
      <Card title={utils.getMessage(props.messages, 'orcamento.label.anexos')}>
        {isNaN(props.oidOrcamento) || props.oidOrcamento === '' ? (
          <Message severity="warn" text="Necessário salvar o orçamento para adicionar anexos" />
        ) : (
          <React.Fragment>
            <div>
              <label className="label-btn-selecionar-anexo" htmlFor="selecao-arquivo">
                {utils.getMessage(props.messages, 'orcamento.label.adicionar')}
              </label>
              <input id="selecao-arquivo" type="file" onChange={props.onSelectAnexo} accept="UTF-8" />
            </div>
            <br />
            {getContent()}
            {props.adicionandoAnexo ? (
              <div className="progress-spinner">
                <ProgressSpinner
                  style={{ width: '50px', height: '50px' }}
                  strokeWidth="8"
                  fill="var(--surface-ground)"
                  animationDuration=".5s"
                />
              </div>
            ) : null}
          </React.Fragment>
        )}
      </Card>
    </div>
  )
}
